import {
  LANGUAGE_CODE_ES_US,
  LANGUAGE_CODE_ZH_CN,
  LANGUAGE_CODE_HI_IN,
  LANGUAGE_CODE_HT_HT,
  LANGUAGE_CODE_PA_IN,
  LANGUAGE_CODE_AR_SA,
  LANGUAGE_CODE_BN_IN,
  LANGUAGE_CODE_FR_FR,
  LANGUAGE_CODE_IT_IT,
  LANGUAGE_CODE_PT_PT,
  LANGUAGE_CODE_PT_BR,
  LANGUAGE_CODE_RU_RU,
  LANGUAGE_CODE_SR_RS,
  LANGUAGE_CODE_UR_PK,
  LANGUAGE_CODE_EN_AU,
  LANGUAGE_CODE_HY_AM,
  LANGUAGE_CODE_ZH_TW,
  LANGUAGE_CODE_HR_HR,
  LANGUAGE_CODE_FIL_PH,
  LANGUAGE_CODE_DE_DE,
  LANGUAGE_CODE_EL_GR,
  LANGUAGE_CODE_GU_IN,
  LANGUAGE_CODE_HE_IL,
  LANGUAGE_CODE_HU_HU,
  LANGUAGE_CODE_HAW,
  LANGUAGE_CODE_HMN,
  LANGUAGE_CODE_ID_ID,
  LANGUAGE_CODE_JA_JP,
  LANGUAGE_CODE_KO_KR,
  LANGUAGE_CODE_KM,
  LANGUAGE_CODE_MK_MK,
  LANGUAGE_CODE_MI,
  LANGUAGE_CODE_ML_IN,
  LANGUAGE_CODE_MY,
  LANGUAGE_CODE_NE_NP,
  LANGUAGE_CODE_NL_BE,
  LANGUAGE_CODE_NL,
  LANGUAGE_CODE_FA_IR,
  LANGUAGE_CODE_PL_PL,
  LANGUAGE_CODE_SI_LK,
  LANGUAGE_CODE_SA,
  LANGUAGE_CODE_TA_IN,
  LANGUAGE_CODE_TE_IN,
  LANGUAGE_CODE_TH_TH,
  LANGUAGE_CODE_TR_TR,
  LANGUAGE_CODE_VI_VN,
  LANGUAGE_CODE_YI_YD,
  LANGUAGE_CODE_SM_WS,
  LANGUAGE_CODE_UK_UA,
  LANGUAGE_CODE_MN_MN,
  LANGUAGE_CODE_AM_AM,
  LANGUAGE_CODE_TI_ET,
} from 'global/constants';
import { InquisitiveLanguageCodes } from 'global/graphql/scalars.type';

type Options = {
  label: string;
  labelSecondary: string;
  value: InquisitiveLanguageCodes;
};

export const BASE_LANGUAGE_OPTIONS: Options[] = [
  {
    label: 'English',
    labelSecondary: 'English',
    value: LANGUAGE_CODE_EN_AU,
  },
  {
    label: 'Spanish',
    labelSecondary: 'Español',
    value: LANGUAGE_CODE_ES_US,
  },
];

export const OTHER_LANGUAGE_OPTIONS: Options[] = [
  {
    label: 'Amharic',
    labelSecondary: 'አማርኛ',
    value: LANGUAGE_CODE_AM_AM,
  },
  {
    label: 'Arabic',
    labelSecondary: 'العربية',
    value: LANGUAGE_CODE_AR_SA,
  },
  {
    label: 'Armenian',
    labelSecondary: 'Հայերեն',
    value: LANGUAGE_CODE_HY_AM,
  },
  {
    label: 'Bengali',
    labelSecondary: 'বাংলা',
    value: LANGUAGE_CODE_BN_IN,
  },
  {
    label: 'Burmese',
    labelSecondary: 'မြန်မာ',
    value: LANGUAGE_CODE_MY,
  },
  {
    label: 'Cambodian (Khmer)',
    labelSecondary: 'ខ្មែរ',
    value: LANGUAGE_CODE_KM,
  },
  {
    label: 'Chinese (Simplified)',
    labelSecondary: '简体中文',
    value: LANGUAGE_CODE_ZH_CN,
  },
  {
    label: 'Chinese (Traditional)',
    labelSecondary: '繁體中文',
    value: LANGUAGE_CODE_ZH_TW,
  },
  {
    label: 'Croatian',
    labelSecondary: 'Hrvatski',
    value: LANGUAGE_CODE_HR_HR,
  },
  {
    label: 'Dutch (Belgium)',
    labelSecondary: 'Nederlands (België)',
    value: LANGUAGE_CODE_NL_BE,
  },
  {
    label: 'Dutch',
    labelSecondary: 'Nederlands',
    value: LANGUAGE_CODE_NL,
  },
  {
    label: 'Filipino',
    labelSecondary: 'Filipino',
    value: LANGUAGE_CODE_FIL_PH,
  },
  {
    label: 'French',
    labelSecondary: 'Français',
    value: LANGUAGE_CODE_FR_FR,
  },
  {
    label: 'German',
    labelSecondary: 'Deutsch',
    value: LANGUAGE_CODE_DE_DE,
  },
  {
    label: 'Greek',
    labelSecondary: 'Ελληνικά',
    value: LANGUAGE_CODE_EL_GR,
  },
  {
    label: 'Gujarati',
    labelSecondary: 'ગુજરાતી',
    value: LANGUAGE_CODE_GU_IN,
  },
  {
    label: 'Haitian Creole',
    labelSecondary: 'Kreyòl Ayisyen',
    value: LANGUAGE_CODE_HT_HT,
  },
  {
    label: 'Hawaiian',
    labelSecondary: 'ʻŌlelo Hawaiʻi',
    value: LANGUAGE_CODE_HAW,
  },
  {
    label: 'Hebrew',
    labelSecondary: 'עברית',
    value: LANGUAGE_CODE_HE_IL,
  },
  {
    label: 'Hindi',
    labelSecondary: 'हिन्दी',
    value: LANGUAGE_CODE_HI_IN,
  },
  {
    label: 'Hmong',
    labelSecondary: 'Hmoob',
    value: LANGUAGE_CODE_HMN,
  },
  {
    label: 'Hungarian',
    labelSecondary: 'Magyar',
    value: LANGUAGE_CODE_HU_HU,
  },
  {
    label: 'Indonesian',
    labelSecondary: 'Bahasa Indonesia',
    value: LANGUAGE_CODE_ID_ID,
  },
  {
    label: 'Italian',
    labelSecondary: 'Italiano',
    value: LANGUAGE_CODE_IT_IT,
  },
  {
    label: 'Japanese',
    labelSecondary: '日本語',
    value: LANGUAGE_CODE_JA_JP,
  },
  {
    label: 'Korean',
    labelSecondary: '한국어',
    value: LANGUAGE_CODE_KO_KR,
  },
  {
    label: 'Macedonian',
    labelSecondary: 'Македонски',
    value: LANGUAGE_CODE_MK_MK,
  },
  {
    label: 'Maori',
    labelSecondary: 'Te Reo Māori',
    value: LANGUAGE_CODE_MI,
  },
  {
    label: 'Malayalam',
    labelSecondary: 'മലയാളം',
    value: LANGUAGE_CODE_ML_IN,
  },
  {
    label: 'Mongolian',
    labelSecondary: 'Монгол',
    value: LANGUAGE_CODE_MN_MN,
  },
  {
    label: 'Nepali',
    labelSecondary: 'नेपाली',
    value: LANGUAGE_CODE_NE_NP,
  },
  {
    label: 'Persian',
    labelSecondary: 'فارسی',
    value: LANGUAGE_CODE_FA_IR,
  },
  {
    label: 'Polish',
    labelSecondary: 'Polski',
    value: LANGUAGE_CODE_PL_PL,
  },
  {
    label: 'Portuguese (Portugal)',
    labelSecondary: 'Português (Portugal)',
    value: LANGUAGE_CODE_PT_PT,
  },
  {
    label: 'Portuguese (Brazil)',
    labelSecondary: 'Português (Brasil)',
    value: LANGUAGE_CODE_PT_BR,
  },
  {
    label: 'Punjabi',
    labelSecondary: 'ਪੰਜਾਬੀ',
    value: LANGUAGE_CODE_PA_IN,
  },
  {
    label: 'Russian',
    labelSecondary: 'Русский',
    value: LANGUAGE_CODE_RU_RU,
  },
  {
    label: 'Sanskrit',
    labelSecondary: 'संस्कृतम्',
    value: LANGUAGE_CODE_SA,
  },
  {
    label: 'Samoan',
    labelSecondary: 'Gagana Sāmoa',
    value: LANGUAGE_CODE_SM_WS,
  },
  {
    label: 'Serbian',
    labelSecondary: 'Српски',
    value: LANGUAGE_CODE_SR_RS,
  },
  {
    label: 'Sinhalese',
    labelSecondary: 'සිංහල',
    value: LANGUAGE_CODE_SI_LK,
  },
  {
    label: 'Tamil',
    labelSecondary: 'தமிழ்',
    value: LANGUAGE_CODE_TA_IN,
  },
  {
    label: 'Telugu',
    labelSecondary: 'తెలుగు',
    value: LANGUAGE_CODE_TE_IN,
  },
  {
    label: 'Thai',
    labelSecondary: 'ไทย',
    value: LANGUAGE_CODE_TH_TH,
  },
  {
    label: 'Tigrinya',
    labelSecondary: 'ትግርኛ',
    value: LANGUAGE_CODE_TI_ET,
  },
  {
    label: 'Turkish',
    labelSecondary: 'Türkçe',
    value: LANGUAGE_CODE_TR_TR,
  },
  {
    label: 'Urdu',
    labelSecondary: 'اردو',
    value: LANGUAGE_CODE_UR_PK,
  },
  {
    label: 'Ukrainian',
    labelSecondary: 'Українська',
    value: LANGUAGE_CODE_UK_UA,
  },
  {
    label: 'Vietnamese',
    labelSecondary: 'Tiếng Việt',
    value: LANGUAGE_CODE_VI_VN,
  },
  {
    label: 'Yiddish',
    labelSecondary: 'ייִדיש',
    value: LANGUAGE_CODE_YI_YD,
  },
];
